// extracted by mini-css-extract-plugin
export default {"Main":"Language_Main__PKqwm","AbstractLeft":"Language_AbstractLeft__c+Zfn","AbstractRight":"Language_AbstractRight__blieE"};